import userSettings from "@astina/paloma-common-ui/src/services/UserSettings";
class CategoryTreeSettings {
    settings = userSettings('paloma-ui.portal.catalog.category-tree');
    expandedCategories = this.settings.get({ expandedCategories: {} }).expandedCategories ?? {};
    /**
     * Whether the user explicitly expanded (true) or collapsed (false) the given
     * category, or undefined if they never toggled it.
     */
    isExpanded(code) {
        return this.expandedCategories[code];
    }
    setExpanded(code, expanded) {
        this.expandedCategories[code] = expanded;
        this.settings.set({ expandedCategories: this.expandedCategories });
    }
}
export default new CategoryTreeSettings();
